const slidingWindowProblems = [
  {
      title: "Maximum Average Subarray I",
      url: "https://leetcode.com/problems/maximum-average-subarray-i/description/"
    },
    {
      title: "Longest Substring Without Repeating Characters",
      url: "https://leetcode.com/problems/longest-substring-without-repeating-characters/"
    },
    {
      title: "Max Consecutive Ones III",
      url: "https://leetcode.com/problems/max-consecutive-ones-iii/"
    },
    {
      title: "Longest Repeating Character Replacement",
      url: "https://leetcode.com/problems/longest-repeating-character-replacement/"
    },
    {
      title: "Minimum Window Substring",
      url: "https://leetcode.com/problems/minimum-window-substring/"
    }
];
export default slidingWindowProblems;